<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/job" />
          <div class="Jobmainbody">
              <div class="jobsSearch">
                <form class="formJob">
                  <dl class="clearfix">
                    <dt>职位搜索：</dt>
                    <dd>
                      <label>
                        <input type="text" value="" class="jobstext txtJobKeyword" placeholder="请输入职位关键字">
                      </label>
                      <input type="submit" class="jobssubmit btnJob" value="搜索" />
                    </dd>
                  </dl>
                </form>
              </div>
              <div class="zhiweicont">
                <dl class="clearfix">
                  <dd class="zhiweititle clearfix">
                    <span class="zhiweidate">最新发布</span>
                    <div class="zhiweismtit">
                      <h4>造价工程师（薪资7000-14000，具体薪资面议，此岗位可兼职，按项目计算薪资）</h4><br/>
                      <p><b>岗位职责:</b><br/>
                        1、参与公司相关项目投资的可行性分析，成本测算，对项目投资决策提供专业性意见和建议；<br/>
                        2、负责在建项目定增工程的预算编制审核工作，对施工过程中实施有效的成本控制；<br/>
                        3、负责在建项目工程的现场签证的造价审核，资料备案等工作；<br/>
                        4、工程竣工时的审核工程承包商的工程结算报价，进行最终的结算与预算的成本差分析，并编写项目结算书与工程成本报告；<br/>
                        5、审核工程项目预算与招标工程量的清单，进行成本费用控制，合同管理；<br/>
                        6、管理工程项目的技术及合同价变更的签证。<br/><br/>
                        <b>任职资格:</b><br/>
                        1、 要求工程造价、市政、水利相关专业专科及以上学历，拥有3年以上工作经验；<br/>
                        2、主要是定额和预决算方面工作内容；<br/>
                        3、要求对公路、市政、水利、水电、房建方面预决算精通。<br/><br/>
                        <b>人事彭经理:</b>&nbsp;18955131765<br/><br/>
                      </p>
                    </div>
                  </dd>
                  <dd class="zhiweiicon"><span>&nbsp;</span></dd>
                </dl>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/us/componets/Banner'
import Tab from '@/views/us/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}

</script>



// WEBPACK FOOTER //
// src/views/us/job.vue